import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  competencyTemplateKeys,
  RequestTypes,
} from '@core/react-query/features/templates/competencyTemplates'
import {
  CompetencyTemplate,
  ICompetencyTemplate,
} from '@core/entities/competency/CompetencyTemplate'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useGetCompetencyTemplateById = (
  payload: RequestTypes['getCompetencyTemplate'],
  options?: UseQueryOptions<
    ICompetencyTemplate,
    RequestErrorType,
    CompetencyTemplate
  >,
) => {
  return useQuery({
    select: CompetencyTemplate.new,
    ...competencyTemplateKeys.getTemplate(payload),
    ...options,
  })
}
